module.exports = __webpack_public_path__ + "img/logoariavertical.ecd0fcec.png";